export default __webpack_public_path__ + "static/media/895.03932b93.png";